var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C6.20913 1.06624e-05 8 1.79087 8 4C8 6.20913 6.20913 7.99999 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 1.48181e-06 4 0ZM4 1C2.34315 1 1 2.34315 1 4C1 5.65685 2.34315 7 4 7C5.65685 6.99999 7 5.65685 7 4C7 2.34315 5.65685 1.00001 4 1Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12 8H7C7.68633 7.48443 8.23505 6.79622 8.58301 6H12V8ZM14 5H8.89941C8.96502 4.67686 9 4.3425 9 4C9 3.6575 8.96502 3.32314 8.89941 3H14V5ZM17 2H8.58301C8.23505 1.20378 7.68633 0.515572 7 0H17V2Z",
    fill: "currentColor",
    style: {
      opacity: 0.5
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 2,
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRead);
export default __webpack_public_path__ + "static/media/icon_read.bda031bba10f1d044a9964600a5dbc32.svg";
export { ForwardRef as ReactComponent };